import { render, staticRenderFns } from "./home-events.vue?vue&type=template&id=1549165e&scoped=true&"
import script from "./home-events.vue?vue&type=script&lang=js&"
export * from "./home-events.vue?vue&type=script&lang=js&"
import style0 from "./home-events.vue?vue&type=style&index=0&id=1549165e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1549165e",
  null
  
)

export default component.exports